<kendo-label text="Geographical Aggregation"
             class="geographical-aggregation-filter">
    <kendo-combobox [data]="geographicalTypes()"
                    [clearButton]="false"
                    [(ngModel)]="internalSelectedValue"
                    [disabled]="isDisabled"
                    [virtual]="virtual"
                    (blur)="handleBlur()">
    </kendo-combobox>
</kendo-label>
